import { useMemo } from 'react';
import { useMutation, useQuery } from 'react-query';
import {
  createProduct,
  getBranchs,
  getCategories,
  getProductById,
  getUnits,
  updateProduct
} from 'src/apis/Products/product';
import { TBaseResponse } from 'src/types/Commons/filter.model';
import { TOption } from 'src/types/Commons/option.model';
import { TProductDto, ProductStatus } from 'src/types/Products/product.model';
import useProductTable from './useProductTable';

export const useCreateProduct = (handleCreateSuccess: (id: number, isSuccess: boolean) => void) => {
  const { id } = useProductTable();
  const { data: productInfo } = useQuery<TBaseResponse<TProductDto>>(
    ['getProducts', id],
    async () => getProductById(id || 0),
    {
      enabled: id != undefined && id > 0,
      keepPreviousData: true
    }
  );
  const { data: categories } = useQuery<TBaseResponse<TOption[]>>(['getCategories', id], async () => getCategories(), {
    keepPreviousData: true
  });
  const { data: units } = useQuery<TBaseResponse<TOption[]>>(['getUnits', id], async () => getUnits(), {
    keepPreviousData: true
  });
  const { data: branchs } = useQuery<TBaseResponse<TOption[]>>(['getBranchs', id], async () => getBranchs(), {
    keepPreviousData: true
  });
  const mutationCreateProduct = useMutation((product: TProductDto) => createProduct(product), {
    onSuccess: async (response: any) => {
      if (response && response.succeeded) {
        handleCreateSuccess(response.data, true);
      } else {
        handleCreateSuccess(0, false);
      }
    },
    onError: () => handleCreateSuccess(0, false)
  });
  const mutationUpdateProduct = useMutation((product: TProductDto) => updateProduct(product), {
    onSuccess: async (response: any) => {
      if (response && response.succeeded) {
        handleCreateSuccess(response.data, true);
      } else {
        handleCreateSuccess(0, false);
      }
    },
    onError: () => handleCreateSuccess(0, false)
  });
  const productStatus = useMemo(() => {
    return [
      { label: 'Kích hoạt', value: ProductStatus.Active.toString() },
      { label: 'Khóa', value: ProductStatus.UnActive.toString() }
    ] as TOption[];
  }, []);
  return {
    productInfo,
    id,
    categories: categories?.data,
    units: units?.data,
    branchs: branchs?.data,
    productStatus,
    mutationCreateProduct,
    mutationUpdateProduct
  };
};
